export default __webpack_public_path__ + "static/media/addSms.a37a8429.svg";